export const PICTURE_STATUS = {
  EMPTY: 'EMPTY',
  FAILED: 'FAILED',
  LOADING: 'LOADING',
  READY: 'READY'
};
